import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TrackerData } from 'src/app/models/types';

@Injectable({
  providedIn: 'root',
})
export class TrackerService {
  private trackers = new Map<string, TrackerData>();

  /**
   * Получить трекер участника по cUid
   */
  getTracker(cUid: string): TrackerData | undefined {
    return this.trackers.get(cUid);
  }

  /**
   * Получить все трекеры
   */
  getAllTrackers(): Map<string, TrackerData> {
    return new Map(this.trackers);
  }

  /**
   * Обновить трекер участника
   */
  updateTracker(cUid: string, data: TrackerData): void {
    this.trackers.set(cUid, data);
  }

  /**
   * Удалить трекер участника
   */
  removeTracker(cUid: string): void {
    this.trackers.delete(cUid);
  }

  /**
   * Очистить все трекеры
   */
  clearTrackers(): void {
    this.trackers.clear();
  }

  /**
   * Установить множество трекеров сразу
   */
  setTrackers(trackers: Map<string, TrackerData>): void {
    this.trackers = new Map(trackers);
  }
}
